export const EmptyString = '—';
export const NoDataString = 'Н/д';
export const EmptyData = ' — ';